import React, { useState } from 'react';
import { 
  Table, Tag, Space, Button, Card, Form, Input, Select, 
  DatePicker, Typography, Modal, Descriptions, Tabs, Upload, Radio, Tree, Drawer, message
} from 'antd';
import { 
  SearchOutlined, ReloadOutlined, PlusOutlined, 
  LeftOutlined
} from '@ant-design/icons';
import './SubEnterprise.css';

const { Option } = Select;
const { Text } = Typography;
const { RangePicker } = DatePicker;

// ══════════════════════════════════════════════
//  合作企业（菜单路径：企业管理 → 合作企业）
//  功能：合作企业列表 + 企业详情（Tab：资料信息）
//  企业详情为内嵌 view 模式，非独立路由
// ══════════════════════════════════════════════

const SubEnterpriseChild = ({ mode } = {}) => {
  
  const [view, setView] = useState('list');
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  
  // 企业标签
  const ENT_TAGS = [
    { value: 'manufacturer', label: '设备制造商', color: 'blue' },
    { value: 'appService', label: '应用服务商', color: 'green' },
    { value: 'solution', label: '产品方案商', color: 'purple' },
    { value: 'distributor', label: '设备分销商', color: 'orange' },
  ];
  const [addEcoTags, setAddEcoTags] = useState([]);

  // 生态企业数据
  const [ecoEnterprises] = useState([
    { key: 'eco1', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7', addTime: '2026-03-20 10:00:00', shareCount: 3, tags: ['manufacturer'] },
    { key: 'eco2', enterpriseName: '捷顺科技股份有限公司', enterpriseId: 'A619355x', addTime: '2026-03-18 14:30:00', shareCount: 1, tags: ['manufacturer', 'solution'] },
    { key: 'eco3', enterpriseName: '深圳拓科智能科技有限公司', enterpriseId: 'SZ-TK-001', addTime: '2026-03-15 09:00:00', shareCount: 0, tags: ['appService', 'distributor'] },
  ]);
  const [addEcoVisible, setAddEcoVisible] = useState(false);
  const [addEcoForm] = Form.useForm();
  const [ecoEntInfo, setEcoEntInfo] = useState(null);
  const [isAuditModalVisible, setIsAuditModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [createForm] = Form.useForm();
  const [auditForm] = Form.useForm();

  const allMenuTree = [
    { title: '首页', key: '1' },
    { title: '物模型管理', key: '2', children: [
      { title: 'IOT类目', key: '2-1', children: [{ title: '新增类目', key: '2-1-1' }, { title: '删除类目', key: '2-1-2' }] },
      { title: '设备能力', key: '2-2' },
    ]},
    { title: '产品管理', key: '3', children: [
      { title: '产品开发', key: '3-1' },
      { title: '产品审核', key: '3-2', children: [{ title: '通过审核', key: '3-2-1' }, { title: '驳回审核', key: '3-2-2' }] },
    ]},
    { title: '应用服务', key: '5', children: [{ title: '应用管理', key: '5-1' }, { title: '套餐管理', key: '5-2' }, { title: '平台商户号', key: '5-3' }, { title: '企业商户号', key: '5-4' }] },
    { title: '订单管理', key: '6', children: [{ title: '增值订单', key: '6-1' }] },
    { title: '设备管理', key: '7', children: [{ title: '设备列表', key: '7-1' }] },
    { title: '数据统计', key: '8', children: [{ title: '用户统计', key: '8-1' }, { title: '收入统计', key: '8-2' }] },
  ];
  const roleMenuKeys = {
    '下级分销': ['1', '3', '5', '6'],
    '下级制造': ['1', '2', '3', '7'],
    '渠道商': ['1', '3', '6'],
    '运营商': ['1', '3', '5', '6', '8'],
  };
  const getMenuTreeByRoles = (roles) => {
    const allowedKeys = new Set((roles || []).flatMap(r => roleMenuKeys[r] || []));
    return allMenuTree.filter(n => allowedKeys.has(n.key));
  };
  const getAllKeys = (nodes) => nodes.flatMap(n => [n.key, ...getAllKeys(n.children || [])]);

  // 模拟数据
  const mockData = [
    {
      key: '1',
      index: 1,
      enterpriseName: '111',
      enterpriseId: 'CV3YyaGN8Y1xKFqk',
      uniqueId: 'B8P',
      phone: '18115178069',
      contact: '1',
      contactPhone: '18115178069',
      registerTime: '2026-02-27 11:11:22',
      
      creditCode: '91320000MA1EXAMPLE',
      licenseUrl: '',
      account: 'admin111',
      roles: ['下级分销'],
      legalPerson: '张三',
      size: '50-100人',
      address: '江苏省南京市建邺区XX路88号',
      email: 'admin@111.com',
      contactRole: '技术总监',
      description: '测试企业简介',
      accounts: [
        { key: '1', account: 'admin111', phone: '18115178069', accountType: '默认注册', roles: ['下级分销'], time: '2026-02-27 11:11:22' }
      ]
    },
    {
      key: '2',
      index: 2,
      enterpriseName: '测试企业1112',
      enterpriseId: 'CV34nx5JihVELUZC',
      uniqueId: '4Nr',
      phone: '',
      contact: '',
      contactPhone: '',
      registerTime: '2026-02-27 11:09:23',
      
      creditCode: '91320000MA2EXAMPLE',
      licenseUrl: '',
      account: 'ssdkzs',
      roles: ['设备制造商', '渠道商'],
      legalPerson: '李四',
      size: '100-500人',
      address: '上海市浦东新区XX路66号',
      email: 'contact@test1112.com',
      contactRole: '项目经理',
      description: '测试企业1112简介',
      accounts: [
        { key: '1', account: 'ssdkzs', phone: '', accountType: '默认注册', roles: ['设备制造商', '渠道商'], time: '2026-02-27 03:09:24' },
        { key: '2', account: 'sub_user01', phone: '13800001111', accountType: '子账号', roles: ['渠道商'], time: '2026-02-28 10:00:00' }
      ]
    },
    {
      key: '3',
      index: 3,
      enterpriseName: 'wd2-com',
      enterpriseId: 'CV39IR3a9AcfxxJK',
      uniqueId: 'PZw',
      phone: '15662166152',
      contact: '11',
      contactPhone: '15662166152',
      registerTime: '2026-02-26 14:33:41',
      billDay:'5',
      creditCode: '91320000MA3EXAMPLE',
      licenseUrl: '',
      account: 'wd2admin',
      roles: ['运营商'],
      legalPerson: '王五',
      size: '20-50人',
      address: '北京市朝阳区XX大厦12层',
      email: 'info@wd2.com',
      contactRole: 'CEO',
      description: 'wd2-com公司简介',
      accounts: [
        { key: '1', account: 'wd2admin', phone: '15662166152', accountType: '默认注册', roles: ['运营商'], time: '2026-02-26 14:33:41' }
      ]
    }
  ];

  const columns = [
    { title: '序号', dataIndex: 'index', key: 'index', width: 60, align: 'center' },
    { title: '企业信息', key: 'enterpriseInfo', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.enterpriseName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>ID: {r.enterpriseId}</div></div>) },
    { title: '唯一标识码', dataIndex: 'uniqueId', key: 'uniqueId' },
    { title: '注册手机号', dataIndex: 'phone', key: 'phone' },
    { title: '联系人', dataIndex: 'contact', key: 'contact' },
    { title: '联系人电话', dataIndex: 'contactPhone', key: 'contactPhone' },
    { title: '注册时间', dataIndex: 'registerTime', key: 'registerTime' },
    { 
      title: '操作', 
      key: 'action',
      render: (_, record) => (
        <Button type="link" size="small" onClick={() => {
            setSelectedRecord(record);
            setView('detail');
          }} style={{ padding: 0 }}>查看详情</Button>
      )
    },
  ];

  const onReset = () => {
    form.resetFields();
  };

  const handleCreate = () => {
    setIsCreateModalVisible(false);
    createForm.resetFields();
  };

  const handleAudit = () => {
    setIsAuditModalVisible(false);
    auditForm.resetFields();
  };

  // 审核弹窗（列表页和详情页共用）
  const auditModal = (
    <Modal
      title="认证审核"
      open={isAuditModalVisible}
      onCancel={() => { setIsAuditModalVisible(false); auditForm.resetFields(); }}
      onOk={handleAudit}
      width={560}
      okText="确认"
      cancelText="取消"
    >
      <Form form={auditForm} layout="horizontal" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }} initialValues={{ auditStatus: 'pass' }}>
        <Form.Item label="审核结果" name="auditStatus">
          <Radio.Group onChange={() => auditForm.resetFields(['roles', 'rejectReason'])}>
            <Radio value="pass">通过</Radio>
            <Radio value="reject">驳回</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item shouldUpdate={(prev, cur) => prev.auditStatus !== cur.auditStatus} noStyle>
          {({ getFieldValue }) => getFieldValue('auditStatus') === 'pass' ? (
            <>
              <Form.Item
                label="企业角色"
                name="roles"
                rules={[{ required: true, message: '请选择企业角色' }]}
              >
                <Select mode="multiple" placeholder="请选择企业角色">
                  <Option value="下级分销">下级分销</Option>
                  <Option value="下级制造">下级制造</Option>
                  <Option value="渠道商">渠道商</Option>
                  <Option value="运营商">运营商</Option>
                </Select>
              </Form.Item>
              <Form.Item shouldUpdate={(prev, cur) => prev.roles !== cur.roles} noStyle>
                {({ getFieldValue: getVal }) => {
                  const selectedRoles = getVal('roles') || [];
                  const filtered = getMenuTreeByRoles(selectedRoles);
                  if (filtered.length === 0) return null;

                  return (
                    <Form.Item label="合并后菜单">
                      <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 4px', maxHeight: 260, overflowY: 'auto' }}>
                        <Tree
                          treeData={filtered}
                          expandedKeys={getAllKeys(filtered)}
                          selectable={false}
                        />
                      </div>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </>
          ) : (
            <Form.Item
              label="驳回原因"
              name="rejectReason"
              rules={[{ required: true, message: '请输入驳回原因' }]}
            >
              <Input.TextArea rows={3} placeholder="请输入驳回原因" />
            </Form.Item>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );

  if (view === 'detail') {
    const r = selectedRecord || {};
    return (
      <div className="sub-enterprise-detail">
        <div className="detail-header" onClick={() => setView('list')} style={{ cursor: 'pointer', marginBottom: 16 }}>
          <LeftOutlined /> 返回 | <strong>企业详情</strong>
        </div>
        
        <Card style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <h2 style={{ margin: 0 }}>{r.enterpriseName}</h2>
                <Tag color={{ '待审核': 'orange', '已认证': 'green', '未通过': 'red' }[r.status]}>{r.status}</Tag>
              </div>
              <p style={{ color: '#999', marginTop: 8 }}>注册于 {r.registerTime}</p>
            </div>
            {r.status === '待审核' && (
              <Button type="primary" onClick={() => setIsAuditModalVisible(true)}>立即审核</Button>
            )}
          </div>
        </Card>

        <Card>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="资料信息" key="1">
              <Descriptions bordered column={2}>
                <Descriptions.Item label="企业名称">{r.enterpriseName}</Descriptions.Item>
                <Descriptions.Item label="企业ID">{r.enterpriseId}</Descriptions.Item>
                <Descriptions.Item label="唯一标识码">{r.uniqueId}</Descriptions.Item>
                <Descriptions.Item label="统一社会信用代码">{r.creditCode || '-'}</Descriptions.Item>
                <Descriptions.Item label="营业执照" span={2}>
                  {r.licenseUrl ? <img src={r.licenseUrl} alt="营业执照" style={{ maxWidth: 200 }} /> : '-'}
                </Descriptions.Item>
                <Descriptions.Item label="注册手机号">{r.phone || '-'}</Descriptions.Item>
                <Descriptions.Item label="登录账号">{r.account || '-'}</Descriptions.Item>
                <Descriptions.Item label="企业角色" span={2}>
                  {(r.roles || []).map(role => <Tag color="blue" key={role}>{role}</Tag>)}
                  {(!r.roles || r.roles.length === 0) && '-'}
                </Descriptions.Item>
                <Descriptions.Item label="法定代表人">{r.legalPerson || '-'}</Descriptions.Item>
                <Descriptions.Item label="公司规模">{r.size || '-'}</Descriptions.Item>
                <Descriptions.Item label="公司地址" span={2}>{r.address || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系人">{r.contact || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系人电话">{r.contactPhone || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系邮箱">{r.email || '-'}</Descriptions.Item>
                <Descriptions.Item label="联系人职务">{r.contactRole || '-'}</Descriptions.Item>
                <Descriptions.Item label="注册时间">{r.registerTime}</Descriptions.Item>
                <Descriptions.Item label="认证状态">
                  <Tag color={{ '待审核': 'orange', '已认证': 'green', '未通过': 'red' }[r.status]}>{r.status}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="公司简介" span={2}>{r.description || '-'}</Descriptions.Item>
              </Descriptions>
            </Tabs.TabPane>
          </Tabs>
        </Card>

        {auditModal}
      </div>
    );
  }

  return (
    <div className="sub-enterprise-container" style={{ padding: '24px' }}>
      {!mode && (<>
      <div style={{ marginBottom: 16 }}>
        <Typography.Title level={4}>合作企业</Typography.Title>
      </div>
      </>)}
      {mode === 'child-only' && (<>
      <div style={{ marginBottom: 16 }}>
        <Typography.Title level={4}>下级企业</Typography.Title>
      </div>
      </>)}

      {!mode && (
        <div style={{ background: '#e6f7ff', padding: '10px 14px', borderRadius: 6, border: '1px solid #91caff', marginBottom: 8 }}>
          <Text style={{ fontSize: 13 }}>当前为分润场景定制，当你(App应用服务商)需要对平台其他企业设置分润，需将企业添加到此列表，在分润配置中配置分润比例。</Text>
        </div>
      )}

      {mode === 'child-only' ? (
        <>

      <Card bordered={false} bodyStyle={{ padding: 0 }}>
        <div style={{ background: '#e6f7ff', padding: '10px 14px', borderRadius: 6, border: '1px solid #91caff', marginBottom: 16 }}>
          <Text style={{ fontSize: 13 }}>您可创建您的下级分销商/分润客户，在分润配置中配置下级企业的分润比例。</Text>
        </div>

        {/* 搜索+创建 */}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <Form form={form} layout="inline" initialValues={{ searchType: 'enterpriseName' }}>
            <Form.Item style={{ marginRight: 10 }}>
              <Input.Group compact>
                <Form.Item name="searchType" noStyle>
                  <Select style={{ width: 100 }} onChange={() => form.resetFields(['keyword', 'enterpriseNameVal'])}>
                    <Option value="enterpriseName">企业名称</Option>
                    <Option value="enterpriseId">企业ID</Option>
                  </Select>
                </Form.Item>
                <Form.Item shouldUpdate={(prev, cur) => prev.searchType !== cur.searchType} noStyle>
                  {({ getFieldValue }) => getFieldValue('searchType') === 'enterpriseName' ? (
                    <Form.Item name="enterpriseNameVal" noStyle>
                    <Select
                      showSearch
                      placeholder="请选择企业名称"
                      allowClear
                      style={{ width: 220 }}
                      optionFilterProp="children"
                    >
                      {mockData.map(item => (
                        <Option key={item.enterpriseId} value={item.enterpriseName}>{item.enterpriseName}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : (
                  <Form.Item name="keyword" noStyle>
                    <Input placeholder="请输入企业ID" allowClear style={{ width: 220 }} />
                  </Form.Item>
                )}
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item name="phone">
            <Input placeholder="注册手机号" allowClear style={{ width: 160 }} />
          </Form.Item>
          <Form.Item name="contact">
            <Input placeholder="联系人" allowClear style={{ width: 140 }} />
          </Form.Item>
          <Form.Item name="uniqueId">
            <Input placeholder="唯一标识码" allowClear style={{ width: 160 }} />
          </Form.Item>
          <Form.Item name="registerDate" label="">
            <RangePicker placeholder={['注册开始日期', '注册结束日期']} />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" icon={<SearchOutlined />}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsCreateModalVisible(true)}>创建下级企业</Button>
        </div>
        <Table 
          columns={columns} 
          dataSource={mockData} 
          pagination={{
            showTotal: (total) => `共${total}条记录`,
            defaultPageSize: 10,
            showSizeChanger: true,
            current: 1,
            pageSizeOptions: ['10', '20', '30']
          }}
        />
      </Card>

      {/* 创建企业抽屉 */}
      <Drawer
        title="创建下级企业"
        width={600}
        open={isCreateModalVisible}
        onClose={() => { setIsCreateModalVisible(false); createForm.resetFields(); }}
        destroyOnClose
        footer={
          <div style={{ textAlign: 'right' }}>
            <Space>
              <Button onClick={() => { setIsCreateModalVisible(false); createForm.resetFields(); }}>取消</Button>
              <Button type="primary" onClick={handleCreate}>保存</Button>
            </Space>
          </div>
        }
      >
        <Form form={createForm} layout="horizontal" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
          <Form.Item label="企业名称" name="name" rules={[{ required: true, message: '请输入企业名称' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="统一社会信用代码" name="code" rules={[{ required: true, message: '请输入统一社会信用代码' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="营业执照" name="license" rules={[{ required: true, message: '请上传营业执照' }]}>
            <Upload listType="picture-card" maxCount={1} beforeUpload={() => false}>
              <div><PlusOutlined /><div style={{ marginTop: 8 }}>上传</div></div>
            </Upload>
          </Form.Item>
          <Form.Item label="注册手机号" name="phone" rules={[{ required: true, message: '请输入注册手机号' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="登录账号" name="account" rules={[{ required: true, message: '请输入登录账号' }]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item label="登录密码" name="password" rules={[{ required: true, message: '请输入登录密码' }]}>
            <Input.Password placeholder="请输入" />
          </Form.Item>
          <Form.Item label="下级企业角色" name="roles" rules={[{ required: true, message: '请选择下级企业角色' }]}>
            <Select mode="multiple" placeholder="请选择下级企业角色">
              <Option value="默认子企业权限">默认子企业权限</Option>
              {/* <Option value="默认三级企业权限">默认三级企业权限</Option> */}
            </Select>
          </Form.Item>
          <Form.Item shouldUpdate={(prev, cur) => prev.roles !== cur.roles} noStyle>
            {({ getFieldValue: getVal }) => {
              const selectedRoles = getVal('roles') || [];
              const filtered = getMenuTreeByRoles(selectedRoles);
              if (filtered.length === 0) return null;
              return (
                <Form.Item label="合并后菜单">
                  <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '8px 4px', maxHeight: 260, overflowY: 'auto' }}>
                    <Tree treeData={filtered} expandedKeys={getAllKeys(filtered)} selectable={false} />
                  </div>
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item label="法定代表人" name="legalPerson"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="公司规模" name="size"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="公司地址" name="address"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系人" name="contact"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系邮箱" name="email"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系人职务" name="contactRole"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="联系人电话" name="contactPhone"><Input placeholder="请输入" /></Form.Item>
          <Form.Item label="公司简介" name="description"><Input.TextArea rows={4} placeholder="请输入公司简介" /></Form.Item>
        </Form>
      </Drawer>

      {auditModal}
      </>) : (

      <Card bordered={false}>
              <Card bordered={false} bodyStyle={{ padding: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                  <Form layout="inline" style={{ flex: 1 }}>
                    <Form.Item>
                      <Space.Compact>
                        <Form.Item name="ecoSearchType" initialValue="name" noStyle>
                          <Select style={{ width: 100 }} onChange={() => {}}>
                            <Option value="name">企业名称</Option>
                            <Option value="id">企业ID</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item noStyle shouldUpdate={(p, c) => p.ecoSearchType !== c.ecoSearchType}>
                          {({ getFieldValue }) => getFieldValue('ecoSearchType') === 'id'
                            ? <Form.Item name="ecoKeyword" noStyle><Input placeholder="请输入企业ID" allowClear style={{ width: 220 }} /></Form.Item>
                            : <Form.Item name="ecoKeyword" noStyle><Select placeholder="请选择企业" style={{ width: 220 }} allowClear showSearch optionFilterProp="children">{ecoEnterprises.map(e => <Option key={e.enterpriseId} value={e.enterpriseId}>{e.enterpriseName}</Option>)}</Select></Form.Item>
                          }
                        </Form.Item>
                      </Space.Compact>
                    </Form.Item>
                    <Form.Item>
                      <Space>
                        <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                        <Button icon={<ReloadOutlined />}>重置</Button>
                      </Space>
                    </Form.Item>
                  </Form>
                  <Button type="primary" icon={<PlusOutlined />} style={{ height: 32 }} onClick={() => { addEcoForm.resetFields(); setEcoEntInfo(null); setAddEcoTags([]); setAddEcoVisible(true); }}>添加合作企业</Button>
                </div>
                <Table dataSource={ecoEnterprises} rowKey="key"
                  pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                  columns={[
                    { title: '企业信息', key: 'ent', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.enterpriseName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.enterpriseId}</Text></div>) },
                    { title: '企业标签', key: 'tags', width: 280, render: (_, r) => (r.tags || []).map(t => { const tag = ENT_TAGS.find(et => et.value === t); return tag ? <Tag color={tag.color} key={t}>{tag.label}</Tag> : null; }) },
                    { title: '添加时间', dataIndex: 'addTime', width: 180, render: (t) => <Text type="secondary">{t}</Text> },
                  ]}
                />
              </Card>
      </Card>
      )}

      {/* 添加合作企业 */}
      <Modal title="添加合作企业" open={addEcoVisible}
        onOk={() => {
          const id = addEcoForm.getFieldValue('enterpriseId');
          if (!id) { message.warning('请输入企业ID'); return; }
          if (!ecoEntInfo) {
            const mockEnts = { 'test': '测试设备企业' };
            if (mockEnts[id]) { setEcoEntInfo({ id, name: mockEnts[id] }); message.info('已查询到企业，请确认后再次点击保存'); }
            else { message.error('未查询到该企业，请确认企业ID'); }
            return;
          }
          if (addEcoTags.length === 0) { message.warning('请选择企业标签'); return; }
          message.success('合作企业已添加');
          setAddEcoVisible(false);
          setEcoEntInfo(null);
          setAddEcoTags([]);
        }}
        onCancel={() => { setAddEcoVisible(false); setEcoEntInfo(null); setAddEcoTags([]); }} okText="保存" cancelText="取消" destroyOnClose width={480}
      >
        <Form form={addEcoForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="enterpriseId" label="企业ID" rules={[{ required: true, message: '请输入企业ID' }]}>
            <Input.Search placeholder="请输入企业ID" enterButton="查询" onSearch={(val) => {
              const mockEnts = { 'test': '测试设备企业' };
              if (mockEnts[val]) { setEcoEntInfo({ id: val, name: mockEnts[val] }); }
              else { setEcoEntInfo(null); if (val) message.warning('未查询到该企业，请确认企业ID'); }
            }} />
          </Form.Item>
          {ecoEntInfo && (
            <div style={{ background: '#f6ffed', padding: '10px 14px', borderRadius: 6, border: '1px solid #b7eb8f', marginBottom: 16 }}>
              <div><Text type="secondary" style={{ fontSize: 12 }}>企业名称：</Text><Text strong>{ecoEntInfo.name}</Text></div>
              <div><Text type="secondary" style={{ fontSize: 12 }}>企业ID：</Text><Text copyable>{ecoEntInfo.id}</Text></div>
            </div>
          )}
          <Form.Item label="企业标签" required>
            <Select mode="multiple" placeholder="请选择企业标签" value={addEcoTags} onChange={setAddEcoTags}>
              {ENT_TAGS.map(t => <Option key={t.value} value={t.value}>{t.label}</Option>)}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SubEnterpriseChild;
